// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"currentColor","d":"M4 2V11C8.97056 11 13 15.0294 13 20H22V22H2V2H4ZM4 20H11C11 16.134 7.86599 13 4 13V20Z"}}]};

const RotationIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'rotation',
    ref,
    icon: element,
  },
));

RotationIcon.displayName = 'RotationIcon';

export default RotationIcon;
